import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LocalDate } from "@js-joda/core";

import useApi from "../../../../shared/hooks/useApi";
import {
  PatientDocumentScheduleId,
  PatientDocumentTypeId,
  PatientTaskInstanceId,
} from "../../../../shared/schema/schema";

// Must match the query key used in useTasksV2Data.ts
export const TASKS_V2_REGULAR_QUERY_KEY = "patientTaskRegulars";

export function useMarkDocumentApproved() {
  const { api } = useApi();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      documentScheduleId,
    }: {
      documentScheduleId: PatientDocumentScheduleId;
    }) => {
      return api.put("./patient_documents/:patientDocumentId/mark_as_approved", {
        path: { patientDocumentId: documentScheduleId },
        body: { approvedDate: LocalDate.now() },
      });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: [TASKS_V2_REGULAR_QUERY_KEY] }),
  });
}

export function useMarkDocumentSubmitted() {
  const { api } = useApi();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      taskInstanceId,
      documentTypeId,
    }: {
      taskInstanceId: PatientTaskInstanceId;
      documentTypeId: PatientDocumentTypeId;
    }) => {
      // Note: this endpoint uses "agency_member" (singular) and "patient_task_instance" (singular)
      // as found in patientsUpcomingTasksCtrl.js markPatientTaskDocumentAsSubmitted
      return api.post(
        "/agencies/:agencyId/agency_member/:agencyMemberId/patient_task_instance/:patientTaskInstanceId/patient_document",
        {
          path: { patientTaskInstanceId: taskInstanceId },
          body: {
            base64: null,
            documentId: documentTypeId,
            documentVersion: null,
            documentTitle: null,
          },
        }
      );
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: [TASKS_V2_REGULAR_QUERY_KEY] }),
  });
}
